/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ /*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  renewalApplicationOverviewAriaLabel: {
    id: 'RenewalApplicationOverview_RenewalApplicationOverviewAriaLabel',
    defaultMessage: 'renewal-application',
  },
  renewalApplicationOverviewPageTitle: {
    id: 'RenewalApplicationOverview_PageTitle',
    defaultMessage: 'Medicaid Annual Renewal',
  },
  overviewTitle: {
    id: 'RenewalApplicationOverview_LabelOverviewTitle',
    defaultMessage: 'Overview',
  },
  overviewDescriptionSubtitle: {
    id: 'RenewalApplicationOverview_LabelDescriptionSubtitle',
    defaultMessage: 'You are renewing the following benefits:',
  },
  overviewHeading: {
    id: 'RenewalApplicationOverview_LabelOverviewHeading',
    defaultMessage: 'Medicaid/Medical Assistance Program',
  },
  individualLabel: {
    id: 'RenewalApplicationOverview_LabelIndividual',
    defaultMessage: 'for these individuals:',
  },
  individualLabelDescription: {
    id: 'RenewalApplicationOverview_LabelIndividualDescription',
    defaultMessage:
      'Please make sure you understand the following steps involved, before continuing:',
  },
  stepOneHeading: {
    id: 'RenewalApplicationOverview_LabelStepOneHeading',
    defaultMessage: 'Prepare',
  },
  stepOneDescription_1: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_1',
    defaultMessage:
      "When you renew, you'll need to update the information we have about you and your household such as:",
  },
  stepOneDescription_2: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_2',
    defaultMessage: 'Personal details: name, SSN',
  },
  stepOneDescription_3: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_3',
    defaultMessage: 'Income: wages, lottery winnings',
  },
  stepOneDescription_4: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_4',
    defaultMessage: 'Benefits: AABD, Medicare Part A, B, C or D, Refugee Cash Assistance',
  },
  stepOneDescription_5: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_5',
    defaultMessage: 'Resources: bank accounts,  vehicles',
  },
  stepOneDescription_6: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_6',
    defaultMessage: 'Expenses: rent, health insurance premiums',
  },
  stepOneDescription_7: {
    id: 'RenewalApplicationOverview_LabelStepOneDescription_7',
    defaultMessage: 'Health Insurance',
  },
  stepTwoHeading: {
    id: 'RenewalApplicationOverview_LabelStepTwoHeading',
    defaultMessage: 'Renew',
  },
  stepTwoDescription_1: {
    id: 'RenewalApplicationOverview_LabelStepTwoDescription_1',
    defaultMessage:
      "To renew your benefits you must review the information we have and provide updates and details of your current income, expenses and child care arrangement information. It's important that we have the latest information so that everyone in the household gets the assistance they are entitled to.",
  },
  stepTwoDescription_2: {
    id: 'RenewalApplicationOverview_LabelStepTwoDescription_2',
    defaultMessage:
      'After submitting your annual renewal, you will get a confirmation message and a copy by email. You will receive a separate notice stating any documents that may be required to verify the updates you have provided. You can upload these documents from the Documents page.',
  },
  stepThreeHeading: {
    id: 'RenewalApplicationOverview_LabelStepThreeHeading',
    defaultMessage: 'Decision',
  },
  stepThreeDescription_1: {
    id: 'RenewalApplicationOverview_LabelStepThreeDescription_1',
    defaultMessage:
      'After your renewal is processed, you will get a notice informing you of the decision. This may take up to 30 days.',
  },
  stepThreeAlert: {
    id: 'RenewalApplicationOverview_LabelStepThreeAlert',
    defaultMessage:
      "Don't worry if you don't have them to hand, you have up to 30 days to submit them after we receive your application.",
  },
  finalInfoOne: {
    id: 'RenewalApplicationOverview_LabelFinalInfo',
    defaultMessage: 'You can save your application, and come back later to finish.',
  },
  finalInfoTwo: {
    id: 'RenewalApplicationOverview_finalInfoTwo',
    defaultMessage: '{loginLink} or {signupLink} to save your application progress.',
  },
  finalInfoTwoLoginLink: {
    id: 'RenewalApplicationOverview_finalInfoTwoLoginLink',
    defaultMessage: 'Log in',
  },
  finalInfoTwoSignupLink: {
    id: 'RenewalApplicationOverview_finalInfoTwoSignupLink',
    defaultMessage: 'sign up',
  },
  startButton: {
    id: 'RenewalApplicationOverview_LabelStartButton',
    defaultMessage: 'Start Renewal',
  },
  applyForBenefitsLink: {
    id: 'RenewalApplicationOverview_BackLink',
    defaultMessage: 'Back',
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program',
  },
});
